import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, setToken } from "../../api";
import { LOGO_URL } from "../../mock";
import { Lock, User } from "lucide-react";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await login(username, password);
      setToken(res.token);
      navigate("/admin");
    } catch (err) {
      setError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center gpm-bg-green px-6">
      <div className="w-full max-w-md bg-white shadow-2xl p-8">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="GPM Classics" className="h-20 w-20 object-contain rounded-full" />
          <h1 className="font-serif-display text-2xl font-bold gpm-text-green mt-4">Admin Portal</h1>
          <p className="text-sm text-gray-500">GPM Classics management</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input data-testid="login-username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" className="w-full pl-10 pr-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm" required />
          </div>
          <div className="relative">
            <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full pl-10 pr-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm" required />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full py-3 gpm-text-cream text-sm font-semibold uppercase tracking-wider transition-transform hover:-translate-y-0.5 disabled:opacity-60" style={{ backgroundColor: "var(--gpm-green)" }}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-xs text-gray-400 text-center mt-6">Demo credentials: admin / gpm-admin-2025</p>
      </div>
    </div>
  );
};

export default AdminLogin;
